import { ApiResponse } from "../../../../types/api.types";
import axiosClient from "../../../../utils/axios";

export interface SelectOption {
  label: string;
  value: string | number; // ✅ value is string in response
}

export interface ApiOptionList {
  rows: SelectOption[]; // ✅ rows not list
  hasMore: boolean;
}

export interface TeamMember {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  nick_name: string;
  image: string | null;
}

export interface TeamDetail {
  id: number;
  name: string;
  department: { id: number; name: string; organization_id: number };
  team_lead: {
    id: number;
    name: string;
    nick_name: string;
    image: string | null;
    email: string;
  };
  members: TeamMember[];
}
export interface DepartmentItem {
  id: number;
  name: string;
  parent?: {
    id: number;
    name: string;
  };
  children?: {
    id: number;
    name: string;
    department_id: number;
  }[];
}

export const getTeamDetails = async (team_id: number) => {
  try {
    const response = await axiosClient.post<ApiResponse<TeamDetail>>(
      `/teams/view`,
      { team_id },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Team Details:", err);
    throw err;
  }
};

export const getTeamsByDepartment = async (department_id: number) => {
  try {
    const response = await axiosClient.post<ApiResponse<ApiOptionList>>(
      `/teams/dropdown`,
      { department_id },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Team Options:", err);
    throw err;
  }
};

export const getDepartmentOptions = async ({
  query,
  limit,
  organization_id,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
  organization_id?: number | string;
}) => {
  try {
    const response = await axiosClient.post<ApiResponse<ApiOptionList>>(
      `/department/dropdown`,
      {
        query,
        limit,
        page,
        organization_id,
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching Department Options : ", err);
    throw err;
  }
};
export const getParentDepartmentOptions = async ({
  query,
  limit,
  organization_id,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
  organization_id?: number | string;
}) => {
  try {
    const response = await axiosClient.post<ApiResponse<ApiOptionList>>(
      `/department/parent-dropdown`,
      {
        query,
        limit,
        page,
        organization_id,
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching Department Options : ", err);
    throw err;
  }
};
export const getSubDepartments = async ({
  organization_id,
  department_id,
  page = 1,
  limit = 10,
}: {
  organization_id: number;
  department_id: number;
  page?: number;
  limit?: number;
}) => {
  try {
    const response = await axiosClient.post<
      ApiResponse<{ rows: DepartmentItem[] }>
    >(`/department/list`, {
      organization_id,
      department_id,
      page,
      limit,
    });

    return response.data;
  } catch (err) {
    console.warn("Error fetching Sub Departments:", err);
    throw err;
  }
};